/* Sculpt Tank fit helper. Uses the approved bust chart.
   Height/weight do not predict size. No requests, storage or tracking events. */
(function () {
  'use strict';
  function recommend(value, unit, rows) {
    const bust = Number(String(value).trim().replace(',', '.'));
    if (!Number.isFinite(bust) || bust <= 0) return { error: 'Enter your full bust measurement to find a starting size.' };
    if (!['cm', 'in'].includes(unit)) return { error: 'Choose centimeters or inches.' };
    const measuredCm = unit === 'in' ? bust * 2.54 : bust;
    if (measuredCm < 50) return { error: 'Please check the unit and measure around the fullest part of your bust, not your bra band.' };
    // Compare against the same rounded endpoints shown in the selected table unit.
    const row = rows.find(r => bust <= (unit === 'cm' ? r.maxCm : Math.round(r.maxCm / 2.54 * 10) / 10));
    return row ? { size: row.label } : { error: 'Your measurement is above this size chart. Contact our team for fit guidance.' };
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = { recommend };
  if (typeof document === 'undefined') return;
  document.querySelectorAll('[data-tank-fit]').forEach(root => {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    const config = JSON.parse(root.querySelector('[data-tank-fit-data]').textContent);
    const bustInput = root.querySelector('[data-fit-bust]');
    const result = root.querySelector('[data-fit-result]');
    const apply = root.querySelector('[data-fit-apply]');
    let unit = 'in', selectedSize = '', entered = null;
    function clearResult() { selectedSize = ''; result.textContent = ''; result.hidden = true; apply.hidden = true; }
    root.querySelectorAll('[data-fit-unit]').forEach(button => button.addEventListener('click', () => {
      const next = button.dataset.fitUnit;
      if (next === unit) return;
      if (!entered) entered = {value: bustInput.value, unit};
      const old = Number(entered.value);
      if (Number.isFinite(old) && old > 0) {
        const cm = entered.unit === 'cm' ? old : old * 2.54;
        bustInput.value = (next === 'cm' ? cm : cm / 2.54).toFixed(1);
      }
      unit = next;
      root.querySelectorAll('[data-fit-unit]').forEach(b => b.setAttribute('aria-pressed', String(b === button)));
      root.querySelector('[data-fit-bust-unit]').textContent = unit === 'cm' ? 'cm' : 'inches';
      bustInput.placeholder = unit === 'cm' ? 'e.g. 100' : 'e.g. 39.4';
      clearResult();
    }));
    bustInput.addEventListener('input', () => { entered = {value: bustInput.value, unit}; clearResult(); });
    root.querySelector('[data-fit-show]').addEventListener('click', () => {
      const answer = recommend(entered ? entered.value : bustInput.value, entered ? entered.unit : unit, config.rows);
      selectedSize = answer.size || '';
      result.hidden = false;
      result.textContent = answer.error || 'Your starting size: ' + selectedSize + '. Based on your full bust measurement.';
      apply.hidden = !selectedSize;
      apply.textContent = selectedSize ? 'Use ' + selectedSize + ' for this set' : '';
    });
    apply.addEventListener('click', async () => {
      if (!selectedSize) return;
      const size = selectedSize;
      const getSizeSelects = () => Array.from(document.querySelectorAll('.moonbundle-option-active button[aria-haspopup="listbox"]')).filter(button => /^(S|M|L|XL|2XL|3XL)$/.test(button.textContent.trim()));
      const count = getSizeSelects().length;
      if (!count) {
        result.textContent = 'Your starting size is ' + size + '. Select it for each tank in your bundle below.';
        return;
      }
      apply.disabled = true;
      try {
        for (let index = 0; index < count; index++) {
          // The bundle re-renders on each change, so reacquire each select.
          const select = getSizeSelects()[index];
          if (!select) throw new Error('Size unavailable');
          if (select.textContent.trim() === size) continue;
          select.click();
          await new Promise(resolve => requestAnimationFrame(resolve));
          const option = Array.from(document.querySelectorAll('[role="listbox"] [role="option"]')).find(item => item.textContent.trim() === size && item.getClientRects().length);
          if (!option || option.disabled) throw new Error('Size unavailable');
          option.click();
          await new Promise(resolve => requestAnimationFrame(resolve));
        }
        const selected = getSizeSelects();
        const confirmed = selected.length === count && selected.every(select => select.textContent.trim() === size);
        result.textContent = confirmed
          ? size + ' selected for each tank in this set. You can change each size below.'
          : 'Your starting size is ' + size + '. Please check each size in your bundle below.';
      } catch (_) {
        result.textContent = 'Your starting size is ' + size + '. Please select an available size for each tank below.';
      } finally { apply.disabled = false; }
    });
  });
})();
